export const PLAN_TOAST_STACK_CLASS = "plan-toast-stack";

export function enablePlanToastStack() {
	if (typeof document === "undefined") {
		return;
	}
	document.body.classList.add(PLAN_TOAST_STACK_CLASS);
}

export function disablePlanToastStack() {
	if (typeof document === "undefined") {
		return;
	}
	document.body.classList.remove(PLAN_TOAST_STACK_CLASS);
}
